export default from './move-post-modal';



// WEBPACK FOOTER //
// ./app/containers/move-post-modal/index.js